import { useDispatch, useSelector } from "react-redux"
import { queryStringChanged, sortSelected } from "../../features/filter/filterSlice";

export default function Header() {
  const {sortOrder,queryString} =useSelector(state=>state.filter);
  const dispatch = useDispatch();

  const handleSort = (e)=>{
    dispatch(sortSelected(e.target.value))
  }

  return (
    <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
      <h1 className="lws-section-title">All Available Jobs</h1>
      <div className="flex gap-4">
        <div className="search-field group flex-1">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input value={queryString} onChange={(e)=> dispatch(queryStringChanged(e.target.value))} type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" />
        </div>
        <select value={sortOrder} onChange={handleSort} id="lws-sort" name="sort" autoComplete="sort" className="flex-1">
          <option value={''}>Default</option>
          <option value={'asc'}>Salary (Low to High)</option>
          <option value={'desc'}>Salary (High to Low)</option>
        </select>
      </div>
    </div>
  )
}